import React from "react";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Breadcrumb";

const PrivacyPolicy = () => {
  const info = useSelector((state) => state.store)?.store?.staticInfo?.[0];

  return (
    <div>
      <Breadcrumb heading={"Privacy Policy"} />
      <div className="container mx-auto py-20">
        <div className="my-4 p-4">
          {info ? (
            <div
              dangerouslySetInnerHTML={{
                __html: info?.privacyPolicy,
              }}
            />
          ) : (
            `Lorem Ipsum is simply dummy text of the printing
             and typesetting industry. Lorem Ipsum has been the industry's 
             standard dummy text ever since the 1500s, when an unknown printer 
             took a galley of type and scrambled it to make a type specimen book. 
             It has survived not only five centuries, but also the leap into electronic 
             typesetting, remaining essentially unchanged.`
          )}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
